import Vue from 'vue'
import { getCurrentClinic } from '@/utils/localStorageManager'

const getPendingAppointmentItems = async (context, patientId) => {
  const clinic = getCurrentClinic()
  // A seleção de pendências é global (checkedItems) e o checkbox da tabela é
  // estado local: ao abrir a aba Conta de OUTRO paciente a tabela aparecia sem
  // marcação enquanto o store ainda guardava a pendência marcada antes, e o
  // "Criar nova guia" montava a guia com paciente/convênio/pendência de outra
  // pessoa (86akkda27). Trocar de paciente zera a seleção; paginar o mesmo
  // paciente a preserva.
  if ((patientId ?? null) !== context.state.patientId) {
    context.commit('setCheckedItems', [])
    context.commit('setPatientId', patientId ?? null)
  }
  context.commit('setLoading', true)
  Vue.prototype.api
    .getPendingAppointmentItems(context.state.page, clinic.id, patientId)
    .then(({ data }) => {
      context.commit('setPendingItems', data)
    })
    .catch(err => {
      console.log(err)
      Vue.prototype.$toast.error(err.message)
    })
    .finally(() => {
      context.commit('setLoading', false)
    })
}

const changePage = (context, page) => {
  context.commit('changePage', page)
}

const changeCheckedItems = (context, checkedItems) => {
  context.commit('setCheckedItems', checkedItems)
}

export default {
  getPendingAppointmentItems,
  changeCheckedItems,
  changePage
}
